import { render, staticRenderFns } from "./InputRegisterFormView.vue?vue&type=template&id=760b70f6&"
import script from "./InputRegisterFormView.vue?vue&type=script&lang=ts&"
export * from "./InputRegisterFormView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports